import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ChangeOrganisationService } from '../../core/services/change-organisation.service';

@Component({
  selector: 'wn-logout-redirector',
  templateUrl: './wn-logout-redirector.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WnLogoutRedirectorComponent implements OnInit {
  private changeOrganisationService = inject(ChangeOrganisationService);

  ngOnInit(): void {
    if (this.changeOrganisationService.shouldChangeOrg) {
      this.changeOrganisationService.clearWnShouldChangeOrgFromLocalStorage();
      this.redirectToAccountManager();
    } else {
      this.redirectToExternalLogoutUrl();
    }
  }

  private redirectToExternalLogoutUrl(): void {
    setTimeout(() => {
      window.location.href = environment.APP_WACKER_NEUSON_LOGOUT_REDIRECT_URL;
    }, environment.DELAY_SHORTEST);
  }

  private redirectToAccountManager(): void {
    setTimeout(() => {
      window.location.href = '/dashboard';
      //window.location.href = environment.ACCOUNT_MANAGER_URL;
    }, environment.DELAY_SHORTEST);
  }
}
